
import { TableCell, TableRow } from "@/components/ui/table";
import { Staff } from "@/types/staff";
import { StaffActions } from "./StaffActions";

interface StaffTableRowProps {
  staff: Staff;
  onDelete: (staff: Staff) => void;
  onStaffUpdated: () => void;
}

export const StaffTableRow = ({ staff, onDelete, onStaffUpdated }: StaffTableRowProps) => {
  return (
    <TableRow>
      <TableCell>{staff.email}</TableCell>
      <TableCell>{staff.mobile_number || "-"}</TableCell>
      <TableCell>{staff.school_id}</TableCell>
      <TableCell>
        <StaffActions
          staff={staff}
          onDelete={onDelete}
          onStaffUpdated={onStaffUpdated}
        />
      </TableCell>
    </TableRow>
  );
};
